import { render, staticRenderFns } from "./ManageClientServices.vue?vue&type=template&id=b7a4e9c8&scoped=true&"
import script from "./ManageClientServices.vue?vue&type=script&lang=js&"
export * from "./ManageClientServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a4e9c8",
  null
  
)

export default component.exports